import React from 'react';

const Toolbar = ({ children }) => (
  <section className="sc__toolbar">
    {children}
  </section>
);

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Toolbar/Toolbar.jsx